import { inject, Pipe, PipeTransform } from '@angular/core';
import {DateHelper } from '../helpers/date-helper-service';

@Pipe({
  name: 'xproj_date'
})
export class XprojDatePipe implements PipeTransform {

  private dateHelper: DateHelper = inject(DateHelper);

  constructor() {}

 public transform(value: Date, format: string = ''): string {
      if (format?.length > 0) {
        return this.dateHelper.formatByString(value, format, '---');
      }
      else {
        return this.dateHelper.formatByString(value, 'yyyy-MM-dd HH:mm:ss', '---');
      }
  }
}
